import { MutationTree } from 'vuex';

import { UserI } from '@/store/auth/state';
import {
  InvoicesStateI,
  InvoiceI,
} from './state';

export const mutations: MutationTree<InvoicesStateI> = {
  setInvoices(state: InvoicesStateI, payload: InvoiceI[]) {
    state.invoices = payload;
  },
  setInvoice(state: InvoicesStateI, payload: InvoiceI) {
    state.invoice = payload;
  },
};
